/**
 * Statsig experiment names (console keys), centralized for reuse.
 */
export const STATSIG_EXPERIMENTS = {
  globalNavV2: "global_nav_v2",
} as const;

export type StatsigExperimentName =
  typeof STATSIG_EXPERIMENTS[keyof typeof STATSIG_EXPERIMENTS];
